import { useQueryClient as reactQueryUseQueryClient } from 'react-query'

export const useQueryClient = reactQueryUseQueryClient
